import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import tooltips from '../resources/estimate-tooltips'

class HelpTooltip extends Component {

    render() {
        const heading = this.props.heading;
        const description = tooltips[this.props.heading].description;
        const defaultValue = tooltips[this.props.heading].default;

        const tooltip = (
            <Tooltip className="control-tooltip" id={`${heading}-tooltip`}>
                <div style={{ maxWidth: '300px', fontSize: '14px' }}>
                    <strong>{heading}</strong><br/>
                    <p style={{ textAlign: 'left' }}>
                        {description}
                    </p>
                    {(defaultValue) && <em>(default: {defaultValue})</em> }
                </div>
            </Tooltip>
        ); 

        return (
            <OverlayTrigger
                placement={this.props.placement}
                overlay={tooltip}
            >
                <i className="fa fa-question-circle" style={{ marginLeft: '4px' }}></i>
            </OverlayTrigger>
        );
    }

}

export default HelpTooltip;
